"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuCheckboxItem = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = require("react");
const menu_item_1 = require("./menu-item");
const MenuCheckboxItem = ({ selected, children, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsxs)(menu_item_1.MenuItem, { ref: ref, ...props, noSelectBackground: true, children: [(0, jsx_runtime_1.jsx)(material_1.ListItemIcon, { children: (0, jsx_runtime_1.jsx)(material_1.Checkbox, { checked: selected }) }), children] }));
};
const MenuCheckboxItemForwardRef = (0, react_1.forwardRef)(MenuCheckboxItem);
exports.MenuCheckboxItem = MenuCheckboxItemForwardRef;
